import React from "react";
import { createRoot } from "react-dom/client";
import KeywordClustring from "../components/free-tools/KeywordClustring";
import ToastProvider from "../components/shared/ToastProvider";

document.addEventListener("DOMContentLoaded", () => {
  const rootElement = document.getElementById("keyword-clustring-main");
  if (rootElement) {
    const root = createRoot(rootElement);
    root.render(
      <>
        <ToastProvider />
        <KeywordClustring />
      </>
    );
  }
});
